export const PUBLIC_URL = process.env.PUBLIC_URL;
export const GIVING_API_BASE_URL = process.env['REACT_APP_GIVING_API_BASE_URL'];
export const MARKETING_SITE_BASE_URL = process.env['REACT_APP_MARKETING_SITE_BASE_URL'];
export const NUCLEUS_DASHBOARD_BASE_URL = process.env['REACT_APP_NUCLEUS_DASHBOARD_BASE_URL'];
export const NUCLEUS_PLATFORM_API_URL = process.env['REACT_APP_NUCLEUS_PLATFORM_API_URL'];
export const NUCLEUS_PLATFORM_HOSTING_API_URL = process.env['REACT_APP_NUCLEUS_PLATFORM_HOSTING_API_URL'];
export const PLATFORM_API_BASE_URL = process.env['REACT_APP_PLATFORM_API_BASE_URL'];
export const SECURE_ELEMENTS_BASE_URL = process.env['REACT_APP_SECURE_ELEMENTS_BASE_URL'];
